import { adminClient as apolloClient } from '@/store/apollo';

import GenerateSiteviewStatisticsGql from '@/store/graphql/cms/mutations/GenerateSiteviewStatistics.gql';
import SiteviewStatisticsGql from '@/store/graphql/cms/queries/SiteviewStatistics.gql';

import GeneratePageviewStatisticsGql from '@/store/graphql/cms/mutations/GeneratePageviewStatistics.gql';
import PageviewStatisticsGql from '@/store/graphql/cms/queries/PageviewStatistics.gql';

import GenerateSalesStatisticsGql from '@/extensions/shop/store/graphql/mutations/GenerateSalesStatistics.gql';
import SalesStatisticsGql from '@/extensions/shop/store/graphql/queries/SalesStatistics.gql';

import ReferrerStatisticsGql from '@/store/graphql/cms/queries/ReferrerStatistics.gql';

export default {
    generateSiteviewStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.cms) variables.cms = parseInt(variables.cms);

            apolloClient
                .mutate({
                    mutation: GenerateSiteviewStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_GenerateSiteviewStatistics))
                .catch(err => reject(err));
        }),
    fetchSiteviewStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.cms) variables.cms = parseInt(variables.cms);

            apolloClient
                .query({
                    query: SiteviewStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_SiteviewStatistics))
                .catch(err => reject(err));
        }),
    generatePageviewStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.cms) variables.cms = parseInt(variables.cms);

            apolloClient
                .mutate({
                    mutation: GeneratePageviewStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_GeneratePageviewStatistics))
                .catch(err => reject(err));
        }),
    fetchPageviewStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.cms) variables.cms = parseInt(variables.cms);

            apolloClient
                .query({
                    query: PageviewStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_PageviewStatistics))
                .catch(err => reject(err));
        }),
    generateSalesStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.shop) variables.shop = parseInt(variables.shop);

            apolloClient
                .mutate({
                    mutation: GenerateSalesStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_GenerateSalesStatistics))
                .catch(err => reject(err));
        }),
    fetchSalesStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.shop) variables.shop = parseInt(variables.shop);
            if (variables.customerGroups) variables.customerGroups = variables.customerGroups.map(id => parseInt(id));

            apolloClient
                .query({
                    query: SalesStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_SalesStatistics))
                .catch(err => reject(err));
        }),
    fetchReferrerStatistics: (variables) =>
        new Promise((resolve, reject) => {
            if (variables.cms) variables.cms = parseInt(variables.cms);

            apolloClient
                .query({
                    query: ReferrerStatisticsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_ReferrerStatistics))
                .catch(err => reject(err));
        })
};
